import { hideLoaderDomUtil, showLoaderDomUtil } from 'client/utils/dom'
import { getHeadersAndEndpointApiUtil } from 'modules/api/utils'
import fetchNetworkUtil from 'modules/training/modules/network/utils/fetch'

async function putApiService (endpointParam, data, options = {}) {
  if (BROWSER) {
    showLoaderDomUtil()
  }

  const {
    headers,
    endpoint
  } = getHeadersAndEndpointApiUtil(endpointParam, options)
  const response = await fetchNetworkUtil(endpoint, {
    credentials: 'include',
    headers,
    method: 'PUT',
    body: JSON.stringify(data)
  })
  const json = await response.json()
  if (response.ok) {
    if (BROWSER) {
      hideLoaderDomUtil()
    }
    return json
  }
  if (BROWSER) {
    hideLoaderDomUtil()
  }
  throw json
}

export default putApiService
